/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
// import { TextAnimationComponent } from '../../text-animation/text-animation.component';

@Component({
  selector: 'chat-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    // TextAnimationComponent
  ],
  templateUrl: './chatInput.component.html',
  styleUrl: './chatInput.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInputComponent {
  @Output() keydownEvent = new EventEmitter<Event>();
  @Input() chatForm!: FormGroup;

  public dataChat = inject(DataChatService);
  public isStreaming = computed(() => this.dataChat.isStreaming())
  public allowSendImage = computed(() => this.dataChat.allowSendImage());
  public inputText: any;

  onKeyPress() {
    this.dataChat.inputText.set(this.inputText)
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type.match(/image\/*/) == null) {
        // TODO: Show alert or toast
        return;
      }
      this.dataChat.selectedImage.set(file);

      const reader = new FileReader();
      reader.onload = (e) => {
        this.dataChat.imagePreviewUrl.set(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  }

  clearImage(evt) {
    evt.preventDefault()
    evt.stopPropagation();

    this.dataChat.selectedImage.set(null);
    this.dataChat.imagePreviewUrl.set(null);
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) 
      fileInput.value = '';
  }

  getUserInputControl(): FormControl {
    return this.chatForm?.get('userInput') as FormControl;
  }

  emitKeyDownEvent(event: Event) {
    this.keydownEvent.emit(event)
  }

}
